import React from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { Row, Col } from "react-bootstrap";

import Button from "../../../../shared/components/Buttons/Button";
import InputTextField from "../../../../shared/components/inputTextField/InputTextField";
import PhoneInputField from "../../../../shared/components/phoneInputField/PhoneInputField";
import {
  toastType,
  toastMessages,
  buttonNameConstants,
  buttonTypeConstants,
  routesPathConstants,
  transactionDefaultData,
  EMPTY_STRING,
  SALE_TRANSACTION_ACTIVITY_TYPES,
} from "../../../../constants";
import {
  PrintIcon,
  GiftCardIcon,
} from "../../../../assets/icons/iconsProvider";
import {
  customToast,
  createCompanyDynamicUrl,
  getReceiptPhoneCountryCode,
  handleEmailOrSMSMessage,
} from "../../../../shared/utility";
import { EMAIL_MESSAGE_TYPES } from "../../../../system/globalEnums";
import SelectedCustomerCard from "../../../../shared/components/customers/SelectedCustomerCard";

const PaymentComplete = ({
  sendEmailOrSMS,
  transactionData,
  updateTransactionData,
  handlePrintReceipt,
  handleShowDraftModal,
  handleAddCustomerClick,
  currentStore,
  ...props
}) => {
  const navigate = useNavigate();
  const initialValues = {
    email: transactionData?.customer?.email || EMPTY_STRING,
    mobile: transactionData?.customer?.mobile || EMPTY_STRING,
  };

  const handleSubmit = (data) => {};
  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ values }) => (
        <div className="payment-cash-card-wrapper">
          <Row className="m-0">
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center"
            >
              <span className="cash-heading">Payment Received</span>
            </Col>
            {transactionData?.customer?.id ? (
              <Col md={12} className="my-3 py-2">
                <SelectedCustomerCard
                  isStoreCredit={true}
                  isDeleteEditOptions={false}
                  transactionId={transactionData?.id}
                  customer={transactionData?.customer}
                  handleAddCustomerClick={handleAddCustomerClick}
                />
              </Col>
            ) : (
              EMPTY_STRING
            )}
            <Col md={12} className="mb-3 d-flex gap-2 mt-3">
              <Button
                type="button"
                label={buttonNameConstants.PRINT}
                handleClick={() => handlePrintReceipt(transactionData, false)}
                buttonType={buttonTypeConstants.LIGHT_PURPLE}
                className="w-100"
                IconImage={PrintIcon}
              ></Button>
              <Button
                type="button"
                className="w-100"
                label={buttonNameConstants.GIFT_RECEIPT}
                buttonType={buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE}
                handleClick={() =>
                  handlePrintReceipt(
                    transactionData,
                    false,
                    buttonNameConstants.GIFT_RECEIPT
                  )
                }
                IconImage={GiftCardIcon}
              ></Button>
            </Col>

            <Col md={12} className="d-flex flex-column gap-2 my-3">
              <div className="w-100 d-flex align-items-center gap-2">
                <span className="text-nowrap receipt-label">
                  Email a receipt:
                </span>
                <Col md={5} className=" ">
                  <InputTextField
                    className="background-gray"
                    name="email"
                    // label="Email"
                    placeHolder="Email"
                    containerDivClassName="text-receipt-input-field"
                  />
                </Col>
                <Col md={4} className="marginLeft-auto ">
                  <Button
                    type="button"
                    label={buttonNameConstants.EMAIL}
                    handleClick={() => {
                      handleEmailOrSMSMessage(
                        EMAIL_MESSAGE_TYPES.TRANSACTION_RECEIPT,
                        true,
                        values,
                        transactionData,
                        customToast,
                        toastMessages,
                        toastType,
                        sendEmailOrSMS
                      );
                    }}
                    buttonType={buttonTypeConstants.LIGHT_PURPLE}
                    className="w-100 email-send-buttons"
                    isDisabled={!values.email}
                    // isDisabled={!transactionData?.customer?.email}
                  />
                </Col>
              </div>
              <div className="w-100 d-flex justify-content-between align-items-center gap-2">
                <span className="text-nowrap receipt-label">
                  Text a receipt:
                </span>
                <Col md={5} className="">
                  <PhoneInputField
                    name="mobile"
                    defaultCountry={getReceiptPhoneCountryCode(
                      transactionData?.customer,
                      currentStore
                    )}
                    className="background-gray"
                  />
                </Col>
                <Col md={4} className="marginLeft-auto">
                  <Button
                    type="button"
                    label={buttonNameConstants.TEXT}
                    handleClick={() => {
                      handleEmailOrSMSMessage(
                        EMAIL_MESSAGE_TYPES.TRANSACTION_RECEIPT,
                        false,
                        values,
                        transactionData,
                        customToast,
                        toastMessages,
                        toastType,
                        sendEmailOrSMS
                      );
                    }}
                    buttonType={buttonTypeConstants.LIGHT_PURPLE}
                    className="w-100 email-send-buttons"
                    // isDisabled={!transactionData?.customer?.mobile}
                    isDisabled={!values.mobile}
                  />
                </Col>
              </div>
            </Col>

            <Col md={12} className="mb-3 d-flex gap-2 mt-3">
              <Button
                type="button"
                label={buttonNameConstants.BACK}
                handleClick={() => {
                  handleShowDraftModal();
                  navigate(
                    createCompanyDynamicUrl(
                      routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION
                    )
                  );
                  updateTransactionData(
                    transactionDefaultData,
                    SALE_TRANSACTION_ACTIVITY_TYPES.RESET_TRANSACTION
                  );
                }}
                buttonType={buttonTypeConstants.GHOST_BUTTON}
                className="w-100"
              ></Button>
              <Button
                type="button"
                className="w-100"
                label={buttonNameConstants.COMPLETE}
                handleClick={() => {
                  handleShowDraftModal();
                  navigate(
                    createCompanyDynamicUrl(
                      routesPathConstants.SELL_AND_TRADE_NEW_TRANSACTION
                    )
                  );
                  updateTransactionData(
                    transactionDefaultData,
                    SALE_TRANSACTION_ACTIVITY_TYPES.RESET_TRANSACTION
                  );
                }}
              ></Button>
            </Col>
          </Row>
        </div>
      )}
    </Formik>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  company: state.authentication.company,
  currentStore: state.store.currentStore,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentComplete);
